/* This file is autogenerated, see readme.md for instructions */
import AttributeSlotSvgIcon from '@bloomreach/banana-theme/icons/attribute-slot.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const AttributeSlotIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <AttributeSlotSvgIcon />
    </Icon>
  );
});

AttributeSlotIcon.displayName = 'AttributeSlotIcon';

export default AttributeSlotIcon;
